export class MapQuery {
    static doOperation(firstOperand, secondOperand, operation) {
        if (MapQuery.isStringCheck(secondOperand) || operation.toUpperCase() === "LIKE") {
            return `LOWER(${firstOperand}) ${operation} '%${secondOperand.toLowerCase()}%'`;
        }
        else {
            return `${firstOperand} ${operation} ${secondOperand}`;
        }
    }
    static isStringCheck(maybeNumber) {
        const checkNumber = Number(maybeNumber);
        return isNaN(checkNumber);
    }
}
